const Delete = (
  <svg
    aria-hidden="true"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2736_11081)">
      <path
        d="M13 5.3335V14.0002C13 14.3538 12.8595 14.6929 12.6095 14.943C12.3594 15.193 12.0203 15.3335 11.6667 15.3335H4.33333C3.97971 15.3335 3.64057 15.193 3.39052 14.943C3.14048 14.6929 3 14.3538 3 14.0002V5.3335"
        stroke="#999999"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 3.3335H15"
        stroke="#999999"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66675 3.33341V0.666748H10.3334V3.33341"
        stroke="#999999"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.99048L6 11.9905"
        stroke="#999999"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.9905L6 7.99048"
        stroke="#999999"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2736_11081">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Delete
